import { render } from "./PopUp.vue?vue&type=template&id=0d19ae70&scoped=true&ts=true&lang=pug"
import script from "./PopUp.vue?vue&type=script&lang=ts"
export * from "./PopUp.vue?vue&type=script&lang=ts"

import "./PopUp.vue?vue&type=style&index=0&id=0d19ae70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d19ae70"]])

export default __exports__